// JS imports :

    import "/node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
    import "./navigation-main";
    import "./team-slider";
    import "./opinions-slider";
    import "./phone";
    import "./buttons";